<template>
  <div v-if="$route.params.id || id_solicitud_contratacion">
    <v-row class="mb-2">
      <v-col cols="12">
        <h4 class="font-weight-black primary--text">
          {{
            version == "nombramiento"
              ? textoDocumentosContratacion
              : "Archivos adjuntos"
          }}
        </h4>
      </v-col>
    </v-row>
    <v-row align="center" v-if="puede_agregar">
      <template v-if="!modoGeneracion">
        <!-- Campos de entrada -->
        <v-col cols="12" md="8">
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field class="rounded-lg" label="Nombre del archivo" placeholder="Nombre" outlined dense
                maxLength="255" v-model="document" :error-messages="documentErrors"
                @blur="$v.document.$touch()"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-file-input class="rounded-lg" outlined label="Adjuntar documento" placeholder="Adjuntar"
                prepend-icon="" dense append-icon="mdi-paperclip" v-model="fileDocument"
                @blur="$v.fileDocument.$touch()" hint="Archivos permitidos .docx, .doc, .xlsx, PDF Tamaño máximo 5GB"
                :error-messages="fileDocumentErrors" persistent-hint></v-file-input>
            </v-col>
            <!-- <v-col cols="12" md="4" v-if="version == 'nombramiento' && mostrarCheckRequiereFirma">
              <v-checkbox class="mt-0" label="Requiere firma" v-model="requireSignature"
                @change="requiredSignature(requireSignature)"></v-checkbox>
            </v-col> -->
          </v-row>
        </v-col>
        <v-col cols="12" md="4" class="d-flex align-center justify-center justify-md-end">
          <!-- Botón Agregar -->
          <div class="text-center text-md-end mb-3 px-0">
            <v-btn rounded color="primary" width="105" :disabled="!document || !fileDocument"
              style="text-transform: none" @click="addDocument">Agregar</v-btn>
          </div>
        </v-col>
      </template>
      <v-col v-else cols="12" class="d-flex justify-end mb-6">
        <v-btn rounded color="primary" style="text-transform: none" :disabled="solicitud?.contrato_generado"
          @click="$emit('generar-archivos')">
          Generar archivos
        </v-btn>
      </v-col>
    </v-row>

    <v-data-table class="elevation-5 rounded-lg striped-rows-docs mx-1" :items="documentos" :headers="headerTable"
      hide-default-footer :hide-default-header="$vuetify.breakpoint.name != 'xs'" :items-per-page="por_pagina"
      style="overflow: hidden;">
      <template v-slot:header="{ props, on }" v-if="$vuetify.breakpoint.name != 'xs'">
        <thead>
          <tr>
            <th v-for="h in props.headers" :key="h.value" :style="{
              'padding-block': '2em',
              width: h.width,
              cursor: h.sortable !== false ? 'pointer' : 'default'
            }" @click="h.sortable !== false && on.sort(h.value)">
              <div :class="h.align === 'left' || h.align === 'start'
                ? 'text-left'
                : h.align === 'right' || h.align === 'end'
                  ? 'text-right'
                  : 'text-center'
                " :style="{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent:
                    h.align === 'left' || h.align === 'start'
                      ? 'flex-start'
                      : h.align === 'right' || h.align === 'end'
                        ? 'flex-end'
                        : 'center'
                }">
                <v-checkbox v-if="h.value === 'seleccionar_archivo' && seleccionarArchivo" v-model="selectAll"
                  hide-details color="primary" density="compact" class="ma-0 pa-0 mr-1"
                  @change="toggleSelectAll"></v-checkbox>
                <p style="
                    font-size: 1.15em;
                    color: black;
                    font-weight: bold;
                    margin: 0;
                  ">
                  {{ h.text }}
                </p>
                <v-icon v-if="h.sortable !== false" small class="ml-1">
                  {{
                    props.options.sortBy.includes(h.value)
                      ? props.options.sortDesc[0]
                        ? "mdi-arrow-down"
                        : "mdi-arrow-up"
                      : "mdi-swap-vertical"
                  }}
                </v-icon>
              </div>
            </th>
          </tr>
        </thead>
      </template>

      <template v-slot:item.nombre_visible="{ item }">
        <span>{{
          item.nombre_visible +
          (item.nombre_original
            ? "." + item.nombre_original.split(".").pop()
            : "")
        }}</span>
      </template>
      <template v-slot:item.requiere_firma="{ item }">
        <div v-if="version == 'nombramiento' && archivosFirmados" class="text-center">
          <span>{{ item.firmado }}</span>
        </div>
      </template>
      <template v-slot:item.action="{ item }">
        <v-row class="d-flex justify-start">
          <!-- Ver -->
          <v-col class="d-flex justify-center" cols="3" v-if="item.ver">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon class="pa-0" v-bind="attrs" v-on="on" color="primary" @click="viewDocument(item)">
                  <v-icon>mdi-eye-outline</v-icon>
                </v-btn>
              </template>
              <span>Mostrar</span>
            </v-tooltip>
          </v-col>

          <!-- Descargar -->
          <v-col cols="3" class="d-flex justify-center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon class="pa-0" v-bind="attrs" v-on="on" color="primary" @click="downloadDocument(item, 1)">
                  <v-icon>mdi-tray-arrow-down</v-icon>
                </v-btn>
              </template>
              <span>Descargar</span>
            </v-tooltip>
          </v-col>

          <!-- Descargar firmado -->
          <v-col cols="3" v-if="item.existe_firmado" class="d-flex justify-center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon class="pa-0" v-bind="attrs" v-on="on" color="primary" @click="downloadDocument(item, 2)">
                  <v-icon>mdi-file-sign</v-icon>
                </v-btn>
              </template>
              <span>{{
                item?.path_doc_firmado?.split(".").pop() === "pdf"
                  ? "Ver documento firmado"
                  : "Descargar documento firmado"
              }}</span>
            </v-tooltip>
          </v-col>

          <!-- Eliminar -->
          <v-col cols="3" v-if="item.puede_eliminar && puede_modificar" class="d-flex justify-center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon class="pa-0" v-bind="attrs" v-on="on" color="primary" @click="deleteDocument(item)">
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
              </template>
              <span>Eliminar</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </template>
      <template v-slot:item.archivos_firmados="{ item }">
        <div v-if="
          version == 'nombramiento' && puede_modificar && archivosFirmados
        ">
          <v-row no-gutters justify="center">
            <v-col cols="auto" v-if="
              item.firmado &&
              item.existe_firmado &&
              item.subir_replazar_archivo
            ">
              <v-btn color="primary" class="rounded-xl" style="text-transform: none" dark
                @click="uploadSignedFiles(item)">
                Reemplazar archivo
                <v-icon right class="ml-2">mdi-tray-arrow-up</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="auto" v-if="
              item.firmado &&
              !item.existe_firmado &&
              item.subir_replazar_archivo
            ">
              <v-btn color="primary" class="rounded-xl" style="text-transform: none" outlined
                @click="uploadSignedFiles(item)">
                Subir archivo
                <v-icon right class="ml-2">mdi-tray-arrow-up</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </template>
      <template v-slot:item.seleccionar_archivo="{ item }">
        <div v-if="seleccionarArchivo">
          <v-row no-gutters justify="center">
            <v-col cols="auto">
              <v-checkbox v-model="selected" :value="item.id" color="primary" @change="selectDocument"></v-checkbox>
            </v-col>
          </v-row>
        </div>
      </template>
      <template v-slot:item.reemplazo_archivo_generado="{ item }">
        <v-row no-gutters justify="center" v-if="item?.documento_contrato && (item?.firmado?.toLowerCase() === 'no')">
          <v-col cols="auto">
            <v-btn color="primary" outlined class="rounded-xl" style="text-transform: none" dark
              @click="actualizarDocumentoNombramientoContratacion(item)">
              Reemplazar archivo
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </v-data-table>
    <v-row justify="center" class="mt-2">
      <v-col cols="auto">
        <nav>
          <div class="pagination">
            <button v-if="!$vuetify.breakpoint.smAndDown" :disabled="numPage == 1 || !totalRegistros"
              @click="controls(-1)">
              Anterior
            </button>
            <button v-if="$vuetify.breakpoint.smAndDown" :disabled="numPage == 1 || !totalRegistros"
              @click="controls(-1)">
              <v-icon v-if="$vuetify.breakpoint.smAndDown">mdi-chevron-left</v-icon>
              <span v-if="!$vuetify.breakpoint.smAndDown">Anterior</span>
            </button>
            <button v-for="(page, index) in pagesToShow" :key="index" @click="changePage(page)"
              :class="{ active: page === numPage, 'page-number': true }">
              {{ page }}
            </button>
            <button v-if="!$vuetify.breakpoint.smAndDown" :disabled="numPage === totalRegistros || !totalRegistros"
              @click="controls(1)">
              Siguiente
            </button>
            <button v-if="$vuetify.breakpoint.smAndDown" :disabled="numPage === totalRegistros || !totalRegistros"
              @click="controls(1)">
              <v-icon v-if="$vuetify.breakpoint.smAndDown">mdi-chevron-right</v-icon>
              <span v-if="!$vuetify.breakpoint.smAndDown">Siguiente</span>
            </button>
            <v-select v-model="por_pagina" :items="perPageOptions" @input="changePerPage" dense outlined hide-details
              class="per-page-selector" :menu-props="{ bottom: true, offsetY: true }"></v-select>
          </div>
        </nav>
      </v-col>
    </v-row>
    <AppDialog v-model="showDialog" max-width="800" title="Vista del documento">
      <template #body>
        <embed :src="documentToView" style="width: 100%; height: 600px" type="application/pdf" />
      </template>
      <template #actions>
        <v-row justify="center" class="mb-4">
          <v-btn color="primary" class="rounded-xl" style="text-transform: none" outlined
            @click="cerrarView">Cerrar</v-btn>
        </v-row>
      </template>
    </AppDialog>
    <AppDialog v-model="showDeleteDialog" max-width="800" title="¿Desea eliminar el documento?">
      <template #body>
        <v-row justify="center">
          <v-col cols="12" class="text-center">
            <span>Si realiza esta acción ya no se podrá deshacer. ¿Desea
              continuar?</span>
          </v-col>
        </v-row>
      </template>
      <template #actions>
        <v-row justify="center" class="mb-4">
          <v-btn color="primary" class="rounded-xl mr-2" style="text-transform: none" outlined
            @click="showDeleteDialog = false">Cancelar</v-btn>
          <v-btn color="primary" class="rounded-xl" dark style="text-transform: none"
            @click="deleteArchivo">Eliminar</v-btn>
        </v-row>
      </template>
    </AppDialog>
    <AppDialog v-model="showUploadDialog" max-width="800" :title="`Subir archivo firmado`">
      <template #body>
        <v-row class="d-flex justify-center align-center my-4">
          <v-col cols="6" md="10">
            <v-file-input class="rounded-lg" outlined label="Adjuntar documento" placeholder="Adjuntar" prepend-icon=""
              dense append-icon="mdi-paperclip" v-model="uploadFile" :error-messages="uploadFileErrors"
              @blur="$v.uploadFile.$touch()"></v-file-input>
            <v-row class="d-flex flex-column pl-3 pt-0" style="color: gray;">
              <span style="font-size: 14px;">Archivos permitidos .docx, .doc, .xlsx, PDF</span>
              <span style="font-size: 14px;">Tamaño máximo 5GB</span>
            </v-row>
          </v-col>
        </v-row>
      </template>
      <template #actions>
        <v-row justify="center" class="mb-4">
          <v-btn color="primary" class="rounded-xl mr-2" style="text-transform: none" outlined
            @click="cerrar">Cancelar</v-btn>
          <v-btn color="primary" class="rounded-xl" dark style="text-transform: none"
            @click="subirArchivo">Guardar</v-btn>
        </v-row>
      </template>
    </AppDialog>
    <AppDialog v-model="showUploadDocumentoContrato" max-width="800" :title="`Subir documento firmado`">
      <template #body>
        <v-row class="d-flex justify-center align-center my-4">
          <v-col cols="6" md="10">
            <v-file-input class="rounded-lg" outlined label="Adjuntar documento" placeholder="Adjuntar" prepend-icon=""
              dense append-icon="mdi-paperclip" v-model="uploadFileContrato" :error-messages="uploadFileContratoErrors"
              @blur="$v.uploadFileContrato.$touch()"></v-file-input>
            <v-row class="d-flex flex-column pl-3 pt-0" style="color: gray;">
              <span style="font-size: 14px;">Archivos permitidos .docx, .doc, .xlsx, PDF</span>
              <span style="font-size: 14px;">Tamaño máximo 5GB</span>
            </v-row>
          </v-col>
        </v-row>
      </template>
      <template #actions>
        <v-row justify="center" class="mb-4">
          <v-btn color="primary" class="rounded-xl mr-2" style="text-transform: none" outlined
            @click="cerrar">Cancelar</v-btn>
          <v-btn color="primary" class="rounded-xl" dark style="text-transform: none"
            @click="subirArchivoContrato">Guardar</v-btn>
        </v-row>
      </template>
    </AppDialog>
  </div>
</template>

<script>
import { requiredIf, maxLength } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import { mapMutations } from "vuex/dist/vuex.common.js";
import { decodeFase } from "@/utils/faseEncoding";
export default {
  name: "DocumentosSolicitud",
  props: {
    id_solicitud_contratacion: {
      type: Number
    },
    puede_agregar: {
      type: Boolean,
      default: false
    },
    puede_modificar: {
      type: Boolean,
      default: false
    },
    version: {
      type: String,
      default: "solicitud"
    },
    archivosFirmados: {
      type: Boolean,
      default: false
    },
    seleccionarArchivo: {
      type: Boolean,
      default: false
    },
    mostrarCheckRequiereFirma: {
      type: Boolean,
      default: true
    },
    modoGeneracion: {
      type: Boolean,
      default: false
    },
    documentoContrato: {
      type: Boolean,
      default: false
    }
  },
  validations() {
    const notEmojis = (value) => {
      const x = value?.match(
        /(\p{Emoji_Presentation}|\p{Extended_Pictographic})/gu
      );
      if (x != null) {
        return false;
      } else {
        return true;
      }
    };
    const validFile = (value) => {
      if (!value) return true;
      const allowedExtensions = ["pdf", "doc", "docx", "xlsx"];
      const extension = value?.name?.split(".")?.pop()?.toLowerCase();
      return allowedExtensions.includes(extension);
    };
    const validFileUpload = (value) => {
      if (!value) return true;
      const allowedExtensions = ["pdf", "doc", "docx", "xlsx"];
      const extension = value?.name?.split(".")?.pop()?.toLowerCase();
      return allowedExtensions.includes(extension);
    };
    const validSizeFile = (value) => {
      if (!value) return true;
      const maxSizeInBytes = 5 * 1024 * 1024 * 1024; // 5 GB
      return value.size <= maxSizeInBytes;
    };
    const validSize = (value) => {
      if (!value) return true;
      const maxSizeInBytes = 5 * 1024 * 1024 * 1024; // 5 GB
      return value.size <= maxSizeInBytes;
    };
    return {
      document: {
        maxLength: maxLength(255),
        notEmojis,
        required: requiredIf(() => this.puede_agregar)
      },
      fileDocument: {
        required: requiredIf(() => this.puede_agregar),
        validFile,
        validSizeFile
      },
      uploadFile: {
        required: requiredIf(() => {
          // ✅ Solo obligatorio si versión es 'nombramiento'
          // y hay al menos un documento firmado
          return (
            this.version === "nombramiento" &&
            Array.isArray(this.documents) &&
            this.documents.some((doc) => doc.firmado === true)
          );
        }),
        validFileUpload,
        validSize
      },
      uploadFileContrato: {
        required: requiredIf(() => {
          return this.showUploadDocumentoContrato;
        }),
        validFileUpload,
        validSize
      }
    };
  },
  data() {
    return {
      documentos: [
        // Ejemplo de documentos, reemplazar con datos reales
        // { nombre_archivo: "Documento1.pdf" },
        // { nombre_archivo: "Documento2.pdf" },
      ],
      document: null,
      fileDocument: null,
      showDialog: false,
      showDeleteDialog: false,
      documentToDelete: null,
      numPage: 1,
      totalRegistros: 0,
      por_pagina: 10,
      perPageOptions: [5, 10, 20, 50, 100],
      requireSignature: false,
      id_solicitud: null,
      documentToView: null,
      id_documento: null,
      idDoc: null,
      uploadFile: null,
      showUploadDialog: false,
      uploadFileContrato: null,
      showUploadDocumentoContrato: false,
      selected: [],
      selectAll: false,
      totalVisible: 3,
      extension: null
    };
  },
  async mounted() {
    // Solo setear faseActual si NO está definida en el store
    // Esto evita sobrescribir el valor correcto de la API
    if (this.$route.query.fase && !this.faseActual) {
      this.SET_FASE_ACTUAL(decodeFase(this.$route.query.fase));
    }
    this.id_solicitud = this.$route.params.id
      ? this.$route.params.id
      : this.id_solicitud_contratacion;

    if (this.id_solicitud) {
      await this.fetchDocumentos();
    }
  },
  methods: {
    ...mapMutations("utils", ["setLoader"]),
    ...mapMutations("solicitud", ["SET_FASE_ACTUAL"]),
    formatFirmado(item) {
      if (item.existe_firmado) {
        return "Firmado";
      } else if (item.firmado === true) {
        return "SI";
      } else {
        return "NO";
      }
    },
    async changePagina(pagina) {
      this.numPage = pagina;
      await this.fetchDocumentos();
    },
    async fetchDocumentos() {
      try {
        let params = {
          page: this.numPage,
          per_page: this.por_pagina,
          fase_actual: this.$route.query.fase
            ? decodeFase(this.$route.query.fase)
            : this.faseActual
        };

        if (
          (this.$route.name === "contrato-detalle" &&
            this.version == "solicitud") ||
          this.$route.name === "solicitud-view"
        ) {
          params.es_detalle = true;
        }

        const response = await this.services.solicitudes.getDocumentsSolicitud(
          this.$route.params.id
            ? this.$route.params.id
            : this.id_solicitud_contratacion,
          params
        );
        if (response.status === 200) {
          this.documentos = response.data.data.map((doc) => ({
            ...doc,
            firmado: this.formatFirmado(doc)
          }));
          this.totalRegistros = Number(response.data.total);
          this.numPage = Number(response.data.page);

          // Si mostrar_capres es true, seleccionar automáticamente
          this.documentos.forEach((doc) => {
            if (doc.mostrar_capres) {
              if (!this.selected.includes(doc.id)) {
                this.selected.push(doc.id);
              }
            }
          });
          this.$emit("selected-documents", this.selected);
          this.$emit("update:totalRegistros", this.totalRegistros);
        }
      } catch (error) {
        this.temporalAlert({
          type: "error",
          message: error.response?.data?.message,
          show: true
        });
        this.documentos = [];
      }
    },
    requiredSignature(value) {
      this.requireSignature = value;
    },
    async addDocument() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      const newDocument = {
        nombre: this.document,
        archivo: this.fileDocument,
        requiere_firma: this.requireSignature
      };

      try {
        this.setLoader(true);

        const formData = new FormData();
        formData.append("nombre", newDocument.nombre);
        formData.append("archivo", newDocument.archivo);
        formData.append(
          "requiere_firma",
          this.version == "nombramiento" ? newDocument.requiere_firma : false
        );
        const response = await this.services.solicitudes.postDocumentsSolicitud(
          this.$route.params.id,
          formData
        );

        if (response.status === 201) {
          this.temporalAlert({
            type: "success",
            message: response.data.message,
            show: true
          });
        }
      } catch (error) {
        this.temporalAlert({
          type: "error",
          message: error.response?.data?.message,
          show: true
        });
      }
      // Resetear los campos
      this.document = null;
      this.fileDocument = null;
      this.requireSignature = false;
      this.$v.$reset();
      this.setLoader(false);
      await this.fetchDocumentos();
      //this.$emit("agregar-documento", newDocument);
    },
    async viewDocument(item) {
      // Lógica para ver el documento
      // Por ejemplo, abrir una nueva ventana o modal con el PDF
      this.idDoc = item.id;
      try {
        this.setLoader(true);
        const response =
          await this.services.solicitudes.downloadDocumentsSolicitud(
            item.id_solicitud,
            this.idDoc,
            String(1)
          );
        if (response.status === 200) {
          let base64String = response.data.archivo;
          const file = this.base64ToFile(base64String, "documento.pdf");
          this.documentToView = URL.createObjectURL(file);
        }
      } catch (error) {
        this.temporalAlert({
          type: "error",
          message: error.response?.data?.message,
          show: true
        });
      }
      this.setLoader(false);
      this.showDialog = true;
    },
    async downloadDocument(item, tipo) {
      // Lógica para descargar el documento
      // Por ejemplo, iniciar la descarga del archivo
      try {
        this.setLoader(true);
        const response =
          await this.services.solicitudes.downloadDocumentsSolicitud(
            this.$route.params.id,
            item.id,
            String(tipo)
          );
        if (response.status === 200) {
          const extension = response.data.tipo;
          if (extension === "application/pdf" && tipo == 2) {
            const file = this.base64ToFile(response.data.archivo, "documento.pdf");
            this.documentToView = URL.createObjectURL(file);
            this.showDialog = true;
          } else {
            let linkSource = `data:${extension};base64,${response.data.archivo}`;
            let downloadLink = document.createElement("a");
            let fileName = `${item.nombre_visible}`;
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
          }
        }
      } catch (error) {
        this.temporalAlert({
          type: "error",
          message: error.response?.data?.message,
          show: true
        });
      }
      this.setLoader(false);
    },
    cerrarView() {
      this.showDialog = false;
      if (this.documentToView && this.documentToView.startsWith('blob:')) {
        URL.revokeObjectURL(this.documentToView);
      }
      this.documentToView = null;
      this.idDoc = null;
    },
    base64ToFile(base64String, fileName = "") {
      const byteString = atob(base64String);
      const arrayBuffer = new ArrayBuffer(byteString.length);
      const uintArray = new Uint8Array(arrayBuffer);
      for (let i = 0; i < byteString.length; i++) {
        uintArray[i] = byteString.charCodeAt(i);
      }

      const file = new File([arrayBuffer], fileName, {
        type: "application/pdf"
      });

      return file;
    },
    deleteDocument(item) {
      // Lógica para eliminar el documento
      this.showDeleteDialog = true;
      this.documentToDelete = item.id;
    },
    async deleteArchivo() {
      // Lógica para confirmar la eliminación del documento
      this.setLoader(true);
      try {
        const response =
          await this.services.solicitudes.deleteDocumentsSolicitud(
            this.$route.params.id,
            this.documentToDelete
          );
        if (response.status === 200) {
          this.temporalAlert({
            type: "success",
            message: response.data.message,
            show: true
          });
          this.$emit("documento-modificado");
        }
      } catch (error) {
        this.temporalAlert({
          type: "error",
          message: error.response?.data?.message,
          show: true
        });
      }
      this.showDeleteDialog = false;
      this.documentToDelete = null;
      this.setLoader(false);
      await this.fetchDocumentos();
    },
    uploadSignedFiles(item) {
      this.id_documento = item.id;
      this.showUploadDialog = true;
    },
    actualizarDocumentoNombramientoContratacion(item) {
      this.id_documento = item.id;
      this.showUploadDocumentoContrato = true;
    },
    cerrar() {
      this.showUploadDialog = false;
      this.uploadFile = null;
      this.$v.uploadFile.$reset();
      this.showUploadDocumentoContrato = false;
      this.uploadFileContrato = null;
      this.$v.uploadFileContrato.$reset();
      this.id_documento = null;
    },
    async subirArchivoContrato() {
      this.$v.uploadFileContrato.$touch();
      if (this.$v.uploadFileContrato.$invalid) {
        return;
      }
      // TODO: Consumir el endpoint para subirArchivoContrato
      // console.log("TODO: Consumir endpoint de subirArchivoContrato con el id_documento:", this.id_documento, " y archivo:", this.uploadFileContrato);

      // this.temporalAlert({
      //   type: "success",
      //   message: "Documento actualizado correctamente",
      //   show: true
      // });
      // this.cerrar();
      try {
        this.setLoader(true);

        const formData = new FormData();
        formData.append("archivo", this.uploadFileContrato);
        const response =
          await this.services.solicitudes.reemplazarDocumentoContrato(
            this.id_documento,
            formData
          );
        if (response.status === 200) {
          this.temporalAlert({
            type: "success",
            message: response.data.message,
            show: true
          });
          this.$emit("documento-modificado");
        }
      } catch (error) {
        this.temporalAlert({
          type: "error",
          message: error.response?.data?.message,
          show: true
        });
      }
      this.cerrar();
      this.setLoader(false);
      await this.fetchDocumentos();
    },
    async subirArchivo() {
      this.$v.uploadFile.$touch();
      if (this.$v.uploadFile.$invalid) {
        return;
      }
      // Lógica para subir el archivo firmado
      try {
        this.setLoader(true);

        const formData = new FormData();
        formData.append("archivo", this.uploadFile);
        const response =
          await this.services.solicitudes.uploadDcocumentoFirmado(
            this.id_documento,
            formData
          );
        if (response.status === 200) {
          this.temporalAlert({
            type: "success",
            message: response.data.message,
            show: true
          });
        }
      } catch (error) {
        this.temporalAlert({
          type: "error",
          message: error.response?.data?.message,
          show: true
        });
      }
      this.cerrar();
      this.setLoader(false);
      await this.fetchDocumentos();
    },
    toggleSelectAll() {
      const pageIds = this.currentPageIds;
      if (this.selectAll) {
        // agregar los ids de la página actual (sin duplicados)
        const newSet = new Set(this.selected);
        pageIds.forEach((id) => newSet.add(id));
        this.selected = Array.from(newSet);
      } else {
        // quitar los ids de la página actual
        this.selected = this.selected.filter((id) => !pageIds.includes(id));
      }
      this.$emit("selected-documents", this.selected);
    },
    selectDocument() {
      this.$emit("selected-documents", this.selected);
    },
    changePage(page) {
      if (page >= 1 && page <= this.totalRegistros && page !== this.numPage) {
        this.numPage = page;
        this.selectAll = false;
        this.fetchDocumentos();
      }
    },
    controls(variable) {
      this.numPage = this.numPage + variable;
      this.selectAll = false;
      this.fetchDocumentos();
    },
    changePerPage(per_page) {
      // Solo setear si no está definida en el store
      if (this.$route.query.fase && !this.faseActual) {
        this.SET_FASE_ACTUAL(decodeFase(this.$route.query.fase));
      }
      this.por_pagina = per_page
      this.numPage = 1;
      this.selectAll = false;
      this.fetchDocumentos();
    }
  },
  computed: {
    ...mapState("solicitud", ["faseActual", "tabOrigen", "solicitud"]),
    textoDocumentosContratacion() {
      if (
        (this.solicitud?.perfil?.toLowerCase() === 'titular' ||
          this.solicitud?.perfil?.toLowerCase() === 'jefe rrhh') && (['P16-F1', 'P16-F2'].includes(this.faseActual)) && (this.solicitud?.boton_activo)) {
        return "Archivos de contratación/nombramiento por autorizar"
      }
      if (['P16-F1', 'P16-F2'].includes(this.faseActual)) {
        return "Archivos de contratación/nombramiento por autorizar"
      }
      if (!['P16-F1', 'P16-F2'].includes(this.faseActual)) {
        return "Archivos de contratación/nombramiento autorizados"
      }

    },
    documentErrors() {
      const errors = [];
      if (!this.$v.document.$dirty) return errors;
      !this.$v.document.required && errors.push("El nombre es obligatorio");
      !this.$v.document.maxLength &&
        errors.push("El nombre no debe exceder los 255 caracteres");
      !this.$v.document.notEmojis &&
        errors.push("El nombre no debe contener emojis");
      return errors;
    },
    fileDocumentErrors() {
      const errors = [];
      if (!this.$v.fileDocument.$dirty) return errors;
      !this.$v.fileDocument.required &&
        errors.push("El archivo es obligatorio");
      !this.$v.fileDocument.validFile &&
        errors.push("Archivos permitidos .docx, .doc, .xlsx, PDF");
      !this.$v.fileDocument.validSizeFile &&
        errors.push("Tamaño máximo 5GB");
      return errors;
    },
    uploadFileErrors() {
      const errors = [];
      if (!this.$v.uploadFile.$dirty) return errors;
      !this.$v.uploadFile.required && errors.push("El archivo es obligatorio");
      !this.$v.uploadFile.validFileUpload &&
        errors.push("Archivos permitidos .docx, .doc, .xlsx, PDF");
      !this.$v.uploadFile.validSize &&
        errors.push("Tamaño máximo 5GB");
      return errors;
    },
    uploadFileContratoErrors() {
      const errors = [];
      if (!this.$v.uploadFileContrato.$dirty) return errors;
      !this.$v.uploadFileContrato.required && errors.push("El archivo es obligatorio");
      !this.$v.uploadFileContrato.validFileUpload &&
        errors.push("Archivos permitidos .docx, .doc, .xlsx, PDF");
      !this.$v.uploadFileContrato.validSize &&
        errors.push("Tamaño máximo 5GB");
      return errors;
    },
    total() {
      return Math.ceil(this.totalRegistros / this.por_pagina);
    },
    headerTable() {
      const base = [
        { text: "Nombre del archivo", value: "nombre_visible", width: "auto", align: "start", sortable: false }
      ];
      // if (this.version === "nombramiento") {
      //   base.push({
      //     text: "Requiere firma",
      //     value: "firmado",
      //     width: "125px",
      //     align: "center",
      //     sortable: false
      //   });
      // }

      // La columna de acciones siempre antes de "Archivos firmados"
      base.push({
        text: "Acciones",
        value: "action",
        align: "center",
        width: "170px",
        sortable: false
      });

      // Ahora agregamos "Archivos firmados" al final si aplica
      // if (this.version === "nombramiento" && this.archivosFirmados) {
      //   base.push({
      //     text: "Archivos firmados",
      //     value: "archivos_firmados",
      //     align: "center",
      //     width: "20%",
      //     sortable: false
      //   });
      // }
      if (this.seleccionarArchivo) {
        base.unshift({
          text: "Seleccionar archivo",
          value: "seleccionar_archivo",
          align: "center",
          width: "35%",
          sortable: false
        });
      }

      if (this.documentoContrato && ["P16-F1", "P19-F3"].includes(this.faseActual)) {
        base.push({
          text: "Archivo",
          value: "reemplazo_archivo_generado",
          align: "center",
          width: "10%",
          sortable: false
        })
      }
      return base;


    },
    currentPageIds() {
      return Array.isArray(this.documentos)
        ? this.documentos.map((d) => d.id)
        : [];
    },
    pagesToShow() {
      const currentPage = this.numPage;
      const total = this.totalRegistros;
      const totalVisible = this.totalVisible;
      const halfVisible = Math.floor(totalVisible / 2);
      let from = currentPage - halfVisible;
      let to = currentPage + halfVisible;

      // Asegurar que las páginas mostradas estén dentro del rango válido
      if (from < 1) {
        from = 1;
        to = Math.min(totalVisible, total);
      }
      if (to > total) {
        to = total;
        from = Math.max(1, total - totalVisible + 1);
      }

      // Crear un array con las páginas que se mostrarán

      const pages = [];
      if (from > 1) {
        pages.push(1);
        if (from > 2) {
          pages.push("..."); // Agregar puntos suspensivos al principio o al final
        }
      }
      for (let i = from; i <= to; i++) {
        pages.push(i);
      }
      if (to < total) {
        if (to < total - 1) {
          pages.push("..."); // Agregar puntos suspensivos  al final
        }
        pages.push(total);
      }
      return pages;
    }
  },
  watch: {
    selected(newSelected) {
      if (newSelected.length === this.totalRegistros) {
        this.selectAll = true;
      } else {
        this.selectAll = false;
      }
      // selectAll debe representar si TODOS los ids de la página actual están seleccionados
      const pageIds = this.currentPageIds;
      if (
        pageIds.length > 0 &&
        pageIds.every((id) => newSelected.includes(id))
      ) {
        this.selectAll = true;
      } else {
        this.selectAll = false;
      }
    }
  }
};
</script>

<style>
/* Asegurar que el border-radius se aplique correctamente */
.rounded-xl.v-data-table {
  overflow: hidden;
}

/* Estilos opcionales para dar formato a la paginación */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
}

.pagination button {
  color: black;
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 3px 8px;
  margin: 0 5px;
}

.pagination button.page-number {
  border-radius: 25px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background-color: white;
  padding: 3px 8px;
  min-width: 25px;
}

.pagination button.page-number:hover:not(.active) {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  border-radius: 25px;
}

.pagination button:hover {
  background-color: #1c1e4d;
  color: #fff;
  border-radius: 25px;
}

.pagination button:hover .v-icon {
  color: #fff;
  transition: none;
}

.pagination button.active {
  background-color: #1c1e4d;
  border-radius: 25px !important;
  color: #fff;
  cursor: default;
  box-shadow: none;
  padding: 3px 8px !important;
  min-width: 25px !important;
}

.pagination button:disabled {
  pointer-events: none;
  opacity: 0.6;
}

.per-page-selector {
  /*margin-left: 15px;*/
  max-width: 85px;
  min-width: 40px;
}

.per-page-selector>>>.v-input__control {
  min-height: 36px !important;
}

.per-page-selector>>>.v-text-field__details {
  display: none;
}

.striped-rows-docs tbody tr:nth-child(odd) {
  background-color: #ededf1;
}

.striped-rows-docs tbody tr:nth-child(even) {
  background-color: white;
}
</style>
